import { spaceClient } from 'lib/axios'
import { setupCache } from 'axios-cache-interceptor'

const API_PREFECTURES = '/api/app/v1/prefectures'
const API_STATIONS = '/api/app/v1/stations'
const API_FACILITIES = '/api/app/v1/facilities'

const TTL = 24 * 60 * 60 * 1000 // 1日（ミリ秒）

const cachedSpaceClient = setupCache(spaceClient, {
  ttl: TTL,
  interpretHeader: false,
})

export const getPrefectures = () =>
  cachedSpaceClient.get(API_PREFECTURES, {
    cache: {
      ttl: TTL,
    },
  })

export const getStations = (prefectureId) =>
  spaceClient.get(`${API_PREFECTURES}/${prefectureId}/stations`)

export const getFacilities = (prefectureId) =>
  spaceClient.get(`${API_PREFECTURES}/${prefectureId}/facilities`)

export const getPrefectureDetail = (slug, locale?) =>
  spaceClient.get(`${API_PREFECTURES}/${slug}`, { headers: { 'Accept-Language': locale || 'ja' } })

export const getStationDetail = (id, locale?) =>
  spaceClient.get(`${API_STATIONS}/${id}`, {
    headers: { 'Accept-Language': locale || 'ja' },
  })

export const getFacilityDetail = (id) => spaceClient.get(`${API_FACILITIES}/${id}`)
